<div class="limited-access-container">
  <div class="icon-container">
    <div class="icon-wrapper">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="InfoOutlined">
          <path
            id="Vector"
            d="M10.0833 6.41668H11.9166V8.25001H10.0833V6.41668ZM10.0833 10.0833H11.9166V15.5833H10.0833V10.0833ZM11 1.83334C5.93998 1.83334 1.83331 5.94001 1.83331 11C1.83331 16.06 5.93998 20.1667 11 20.1667C16.06 20.1667 20.1666 16.06 20.1666 11C20.1666 5.94001 16.06 1.83334 11 1.83334ZM11 18.3333C6.95748 18.3333 3.66665 15.0425 3.66665 11C3.66665 6.95751 6.95748 3.66668 11 3.66668C15.0425 3.66668 18.3333 6.95751 18.3333 11C18.3333 15.0425 15.0425 18.3333 11 18.3333Z"
            fill="#4286B9"
          />
        </g>
      </svg>
    </div>
  </div>
  <div class="text-container">
    <div class="title">
      {{ title }}
    </div>
    <div class="description">
      {{ description }}
    </div>
  </div>
</div>
